import React, { forwardRef, useRef, useState } from 'react';
import { Button, Empty } from 'antd';
import { DiscardConfirm } from 'app/modules/lending/components/actions';
import classNames from 'classnames';
import {
    CopyOutlined,
    DeleteOutlined,
    EditOutlined,
    UndoOutlined,
} from '@ant-design/icons';
import s from './index.module.scss';
import { Confirm } from 'app/shared/confirm/confirm';
import { useDesktop } from 'app/hooks/useDesktop';
import { useClickOutside } from 'app/hooks/useClickOutside';
import { ScrollToHashElement } from 'app/components/ScrollToHashElement';

export const DeleteConfirm = ({ onDelete, hideConfirmDelete }) => {
    const confirm = () => {
        onDelete();
        hideConfirmDelete();
    };
    return (
        <>
            <div>Вы уверены, что хотите удалить раздел?</div>
            <div className={s.controls}>
                <Button onClick={hideConfirmDelete}>Нет</Button>
                <Button onClick={confirm} className={s.confirm_btn}>
                    Да
                </Button>
            </div>
        </>
    );
};

export const LendingSection = forwardRef(
    (
        {
            children,
            isAdmin,
            changed,
            show,
            actions,
            size,
            isEmpty,
            onDeleteEmpty,
            id,
            dataId,
        },
        ref
    ) => {
        const [isShowActions, setIsShowActions] = useState(true);
        const isDesktop = useDesktop();
        const { onEdit, onDiscard, onDelete, onCopy, onUp, onDown } = actions;
        const [confirmDiscardModal, setConfirmDiscardModal] = useState(false);
        const [deleteDiscardModal, setDeleteDiscardModal] = useState(false);

        const discardRef = useRef();
        const deleteRef = useRef();
        const showConfirmDiscard = () => {
            setConfirmDiscardModal(true);
        };
        const hideConfirmDiscard = () => {
            setConfirmDiscardModal(false);
        };
        const showConfirmDelete = () => {
            setDeleteDiscardModal(true);
        };
        const hideConfirmDelete = () => {
            setDeleteDiscardModal(false);
        };

        useClickOutside(discardRef, hideConfirmDiscard);
        if (!show && !isAdmin) return null;

        return (
            <ScrollToHashElement>
                <div
                    id={id || undefined}
                    data-section-id={dataId || id}
                    onMouseEnter={() => setIsShowActions(true)}
                    onMouseLeave={() => setIsShowActions(false)}
                    className={classNames('lending-section', {
                        'lending-section__dashed': isAdmin,
                        'lending-section__dashed_changed': changed,
                    })}
                    style={{
                        width: `${size}%`,
                        cursor: 'pointer',
                        paddingBottom: `25px`,
                        paddingTop: `25px`,
                        flex: size && size / 100,
                    }}
                >
                    {isAdmin && isShowActions && !isEmpty ? (
                        <>
                            <div className={s.actions}>
                                {onEdit ? (
                                    <Button
                                        title={'Редактировать'}
                                        icon={<EditOutlined />}
                                        onClick={onEdit}
                                    />
                                ) : null}
                                {onDiscard && isDesktop ? (
                                    <Confirm
                                        onConfirm={onDiscard}
                                        description={
                                            'Вы уверены, что хотите сбросить изменения?'
                                        }
                                    >
                                        <Button
                                            title={'Сбросить'}
                                            icon={<UndoOutlined />}
                                        />
                                    </Confirm>
                                ) : (
                                    <div
                                        className={`${s.mobile_menu} ${s.discard_wrap}`}
                                        ref={discardRef}
                                    >
                                        {confirmDiscardModal && (
                                            <div className={s.discard_content}>
                                                <DiscardConfirm
                                                    onDiscard={onDiscard}
                                                    hideConfirmDiscard={
                                                        hideConfirmDiscard
                                                    }
                                                />
                                            </div>
                                        )}
                                        <Button
                                            title={'Сбросить'}
                                            icon={<UndoOutlined />}
                                            onClick={showConfirmDiscard}
                                        />
                                    </div>
                                )}
                                {onCopy ? (
                                    <Button
                                        onClick={onCopy}
                                        title={'Скопировать'}
                                        icon={<CopyOutlined />}
                                    />
                                ) : null}
                                {onDelete && isDesktop ? (
                                    <Confirm
                                        onConfirm={onDelete}
                                        description={
                                            'Вы уверены, что хотите удалить раздел?'
                                        }
                                    >
                                        <Button
                                            title={'Удалить'}
                                            icon={<DeleteOutlined />}
                                        />
                                    </Confirm>
                                ) : (
                                    <div
                                        className={`${s.mobile_menu} ${s.discard_wrap}`}
                                        ref={deleteRef}
                                    >
                                        {deleteDiscardModal && (
                                            <div className={s.discard_content}>
                                                <DeleteConfirm
                                                    onDelete={onDelete}
                                                    hideConfirmDelete={
                                                        hideConfirmDelete
                                                    }
                                                ></DeleteConfirm>
                                            </div>
                                        )}
                                        <Button
                                            title={'Удалить'}
                                            icon={<DeleteOutlined />}
                                            onClick={showConfirmDelete}
                                        />
                                    </div>
                                )}
                            </div>
                        </>
                    ) : null}
                    <div
                        className={`lending-section__content ${
                            isEmpty
                                ? 'd-flex justify-content-center align-items-center'
                                : ''
                        }`}
                    >
                        {show ? (
                            children
                        ) : (
                            <Empty
                                className={'m-auto'}
                                description={
                                    'В этом разделе пока ничего нет. Добавьте содержимое'
                                }
                            />
                        )}
                    </div>
                </div>
            </ScrollToHashElement>
        );
    }
);
